import React from "react";

interface InfoTableProps {
  title: string;
  data: { label: string; value: React.ReactNode }[];
  button?: React.ReactNode;
  toogle?: React.ReactNode;
  buttonSideTitle?: React.ReactNode;
}

export function InfoTable({
  title,
  data,
  button,
  toogle,
  buttonSideTitle,
}: InfoTableProps) {
  const formatValue = (value: React.ReactNode): React.ReactNode => {
    if (typeof value !== "string") {
      return value;
    }
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;

    if (isoDateRegex.test(value)) {
      try {
        const date = new Date(value);
        const options: Intl.DateTimeFormatOptions = {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        };

        return new Intl.DateTimeFormat("pt-BR", options)
          .format(date)
          .replace(",", "");
      } catch (error) {
        return value;
      }
    }

    return value;
  };
  return (
    <div className="mb-4">
      <div className="grid grid-cols-2">
        <h4 className="font-semibold mb-2 text-2xl col-span-2">
          {title}
          {buttonSideTitle}
        </h4>
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <span
              className={`p-2 border border-gray/50 border-r-0 flex items-center ${
                index % 2 === 0 ? "bg-white/30" : "bg-white/50"
              }`}
            >
              {item.label}:
            </span>
            <span
              className={`p-2 rounded-r-md border border-gray/50 border-l-0 flex items-center ${
                index % 2 === 0 ? "bg-white/30" : "bg-white/50"
              }`}
            >
              {formatValue(item.value)}
            </span>
          </React.Fragment>
        ))}
      </div>
      {toogle && <div className="">{toogle}</div>}
      {button && (
        <div className="flex mt-4 items-center justify-between">{button}</div>
      )}
    </div>
  );
}
